import { AttivitaDTO, AttivitaSortRequest } from "@api/client";
import {
	closestCenter,
	DndContext,
	PointerSensor,
	useSensor,
	useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
	arrayMove,
	SortableContext,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useAppDispatch } from "core/store/hooks";
import { activitiesSort } from "pages/private/activities/_redux/actions";
import { useEffect, useState } from "react";
import AppButton from "shared/design-system/components/app-button";
import AppModal from "shared/design-system/components/app-modal";
import { AppToastService } from "shared/design-system/components/app-toast/app-toast.service";
import ModalActivityOrdersItem from "./modal-activity-orders-item";

interface Props {
	show: boolean;
	onHide: (reload?: boolean) => void;
	activities: AttivitaDTO[] | null | undefined;
}

const ModalActivityOrders: React.FC<Props> = (props) => {
	const { activities, onHide, show } = props;

	const dispatch = useAppDispatch();

	const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 5,
			},
		})
	);

	const [items, setItems] = useState<AttivitaDTO[]>([]);

	const handleCancel = () => {
		onHide();
	};

	const handleSave = () => {
		let list: AttivitaSortRequest[] = items?.map((item, i) => ({
			id: item.id,
			order: i,
		}));

		dispatch(activitiesSort(list))
			.unwrap()
			.then(() => {
				AppToastService.success("CAA ordinate correttamente");

				onHide(true);
			});
	};

	const handleDragEnd = (event: any) => {
		const { active, over } = event;

		if (active.id !== over?.id) {
			const oldIndex = items.findIndex((item) => item.id === active.id);
			const newIndex = items.findIndex((item) => item.id === over.id);
			setItems((items) => arrayMove(items, oldIndex, newIndex));
		}
	};

	useEffect(() => {
		if (activities) {
			setItems([...activities]);
		}
	}, [activities]);

	return (
		<AppModal
			show={show}
			onClose={handleCancel}
			title="Ordina CAA"
			subtitle="Trascina gli elementi nell'elenco per ordinarli"
			actions={
				<>
					<AppButton variant="outline" onClick={handleCancel}>
						Annulla
					</AppButton>

					<AppButton onClick={handleSave}>
						<i className="fas fa-save me-2" />
						Salva
					</AppButton>
				</>
			}
		>
			<DndContext
				sensors={sensors}
				collisionDetection={closestCenter}
				onDragEnd={handleDragEnd}
				modifiers={[restrictToVerticalAxis]}
			>
				<SortableContext
					items={items
						?.map((item) => item.id)
						.filter((id): id is number => id !== undefined)}
					strategy={verticalListSortingStrategy}
				>
					<ul>
						{items?.map((item, i) => (
							<ModalActivityOrdersItem key={`activity-${i}`} item={item} />
						))}
					</ul>
				</SortableContext>
			</DndContext>
		</AppModal>
	);
};
export default ModalActivityOrders;
